
import ToolServices from '@/providers/tools';
import { PRESENTATION_MODE_EVENTS, EVENT_TYPES, SOCKET_EVENTS }  from '@/content/values/ed-presentation-mode.values';
import SocketEventManage from '@/core/interfaces/socketEventManage.interface';
import { HOMEWORKS_EVENTS, HOMEWORK_SOCKET_EVENTS } from '@/homework/values/homeworks.values';

export const APP_STORE_NAME = 'AppStore';

export const APP_STORE_ACTIONS = {
  ON_MEMBERS_POSITION: 'onMembersPosition',
  SEND_TEACHER_POSITION: 'sendTeacherPosition',
  CLEAN_TEACHER_POSITION: 'cleanTeacherPosition',
  GET_FILE_EXT_NOT_ALLOWED:'getFileExtNotAllowed'
}

export const APP_STORE_MUTATIONS = {
  TOGGLE_SIDEBAR: 'toggleSidebar',
  CHANGE_ROUTER: 'changeRouter',
  CHANGE_FOOTER_TYPE: 'changeFooterType',
  SET_COPYRIGHTS_COLOR: 'setCopyrightsColor',
  SET_HEADER_VISIBLE: 'setHeaderVisible',
  SET_USER_POSITION: 'setUserPosition',
  SET_USER_SOCKET: 'setUserSocket',
  SET_MEMBER_POSITION: 'setMemberPosition',
  SET_SOCKET_CONNECTED: 'setSocketConnected',
  CLEAN_SOCKETS_AND_MEMBERS: 'cleanSocketsAndMembers',
  SET_PRESENTATION_SOCKET_CONNECTED: 'setPresentationSocketConnected',
  SET_ACTIVE_SCHOOL_DAYS_LOADED: 'setActiveSchoolDaysLoaded',
  SET_INSTITUTIONS_LOADED: 'setInstitutionsLoaded',
  SET_EXP_INDEXDB: 'setExpIndexDBDocumentTime',
  SET_ACTIVE_INDEXDB: 'setActiveIndexDB',
  SET_FILE_EXT_NOT_ALLOWED: 'setFileExtNotAllowed',
  SET_USER_MODE: 'setUserMode',
  UPDATE_PREVIOUS_DISCONNECTION_SOCKET: 'updatePreviousDisconnectionSocket',
  UPDATE_SHOW_CONNECT_MANUALLY_BUTTON: 'updateShowConnectManuallyButton',
  SET_SIDEBAR_BUTTON: 'setSidebarButton',
  UPDATE_BOARD_PREVIOUS_DISCONNECTION_SOCKET: 'updateBoardPreviousDisconnectionSocket',
  SET_APP_READY: 'setAppReady',
  SET_ACTIVE_WEBVIEW: 'setActiveWebwiew',
  SET_OFFLINE_MODE: 'setOfflineMode',
  SET_EXPAND_CALENDAR:'setExpandCalendar',
  ADD_ERROR_LOG: 'addErrorLog',
  CLEAN_ERROR_LOG: 'cleanErrorLog',
}

export const _APP_STORE = ToolServices.getStore(
  APP_STORE_NAME,
  APP_STORE_ACTIONS,
  APP_STORE_MUTATIONS
);

export const APP_API = {
  INITIAL_DATA: 'content/initialData',
  BACKUP_DATA: 'externalbackup/',
  HEALTH_API: 'actuator/health'
}

export const APP_SOCKET_EVENTS = {
  // SocketIO Migration - Disable presence events
  // TEACHER_VIEW_UPDATE_LOCATION: '/interactive/topic/{classId}/teacherView.updateLocation',
  // TEACHER_VIEW_ON_HOME: '/interactive/topic/{classId}/teacherView.onHome',
  // TEACHER_VIEW_STUDENT_ON_HOME: '/interactive/topic/{classId}/teacherView.studentOnHome',

  TEACHER_START_CALL: '/interactive/topic/{classId}/teacher.startCall',
  TEACHER_START_CALL_REQUEST: '/app/interactive/teacher.startCall',

  TEACHER_END_CALL: '/interactive/topic/{classId}/teacher.endCall',
  TEACHER_END_CALL_REQUEST: '/app/interactive/teacher.endCall',

  STUDENT_CONNECT_CALL: '/app/interactive/student.connectCall',
  MEETING_EVENTS: '/interactive/topic/{roomId}',

  COMMAND_CALL: '/interactive/topic/{classId}/call.command',
  COMMAND_CALL_REQUEST: '/app/interactive/call.command',

  USER_CLASS_CONNECT: '/app/interactive/classes.join',

  MEDIA_ASSET_CONVERTED: '/app/interactive/media.asset.converted',

}

export const SOCKET_ON_CONNECT_EVENT : string = 'SOCKET_ON_CONNECT_EVENT';

export const APP_SOCKET_MESSAGES_TYPE = {
  ON_HOME: 'onHome',
  LEAVE: 'Leave',
  UPDATE_LOCATION: 'updateLocation',
  START_CALL: 'startCall',
  END_CALL: 'endCall',
  COMMAND_CALL: 'commandCall',
  
}

//Events to classes
export const APP_SOCKET_CLASS_MESSAGES_TYPE = {
  CLASS_ADDED: 'CLASS_ADDED',
  CLASS_DELETED: 'CLASS_DELETED'
}

export const CLASS_MESSAGES_TYPE : string [] = [
  APP_SOCKET_CLASS_MESSAGES_TYPE.CLASS_ADDED,
  APP_SOCKET_CLASS_MESSAGES_TYPE.CLASS_DELETED,
];

export const LOAD_CLASS_MESSAGES : string = 'LOAD_CLASS_MESSAGES';

//Events to room classes
export const APP_SOCKET_ROOM_CLASS_MESSAGES_TYPE = {
  MEETING_ADDED: 'MEETING_ADDED',
  MEETING_REMOVED: 'MEETING_REMOVED'
}

export const ROOM_CLASS_MESSAGES_TYPE : string [] = [
  APP_SOCKET_ROOM_CLASS_MESSAGES_TYPE.MEETING_ADDED,
  APP_SOCKET_ROOM_CLASS_MESSAGES_TYPE.MEETING_REMOVED,
];

export const LOAD_ROOM_CLASS_MESSAGES : string = 'LOAD_ROOM_CLASS_MESSAGES';

//Events to templates
export const APP_SOCKET_TEMPLATE_MESSAGES_TYPE = {
  TEMPLATE_ADDED: 'TEMPLATE_ADDED',
  TEMPLATE_REMOVED: 'TEMPLATE_REMOVED',
  TEMPLATE_UPDATED: 'TEMPLATE_UPDATED'
}

export const TEMPLATE_MESSAGES_TYPE : string [] = [
  APP_SOCKET_TEMPLATE_MESSAGES_TYPE.TEMPLATE_ADDED,
  APP_SOCKET_TEMPLATE_MESSAGES_TYPE.TEMPLATE_REMOVED,
  APP_SOCKET_TEMPLATE_MESSAGES_TYPE.TEMPLATE_UPDATED
];

export const LOAD_TEMPLATE_MESSAGES : string = 'LOAD_TEMPLATE_MESSAGES';

//Events to grade levels
export const APP_SOCKET_GRADE_LEVEL_MESSAGES_TYPE = {
  GRADE_LEVEL_ADDED: 'GRADE_LEVEL_ADDED',
  GRADE_LEVEL_DELETED: 'GRADE_LEVEL_DELETED'
}

export const GRADE_LEVEL_MESSAGES_TYPE : string [] = [
  APP_SOCKET_GRADE_LEVEL_MESSAGES_TYPE.GRADE_LEVEL_ADDED,
  APP_SOCKET_GRADE_LEVEL_MESSAGES_TYPE.GRADE_LEVEL_DELETED,
];

export const LOAD_GRADE_LEVEL_MESSAGES : string = 'LOAD_GRADE_LEVEL_MESSAGES';

export const MEMBERS_POSITION_COLORS = [
  '#ffb100',
  '#260dad',
  '#cc0000',
  '#f12fac',
]

export const STUDENT_SOCKET_CLASS_EVENTS : SocketEventManage[] = [
  // SocketIO Migration - Disable presence events
  // {
  //   socketEvent: APP_SOCKET_EVENTS.TEACHER_VIEW_ON_HOME,
  //   appEvent: 'listenMembersPosition',
  //   socketEmitEvents: [
  //     {socketEmit: APP_SOCKET_EVENTS.TEACHER_VIEW_STUDENT_ON_HOME, messageType: null}
  //   ]
  // },
  // {
  //   socketEvent: APP_SOCKET_EVENTS.TEACHER_VIEW_UPDATE_LOCATION,
  //   appEvent: 'listenMembersPosition',
  //   socketEmitEvents: []
  // },
  {
    socketEvent: APP_SOCKET_EVENTS.TEACHER_START_CALL,
    appEvent: 'listenIncomingCall',
    socketEmitEvents: [
      {socketEmit: APP_SOCKET_EVENTS.STUDENT_CONNECT_CALL, messageType: null}
    ]
  },
  {
    socketEvent: APP_SOCKET_EVENTS.TEACHER_END_CALL,
    appEvent: 'listenEndCall',
    socketEmitEvents: []
  },
  {
    socketEvent: APP_SOCKET_EVENTS.COMMAND_CALL,
    appEvent: 'listenCommandCall',
    socketEmitEvents: []
  },
  {
    socketEvent: APP_SOCKET_EVENTS.USER_CLASS_CONNECT,
    appEvent: 'listenCommandClasses',
    socketEmitEvents: [
      {socketEmit: APP_SOCKET_EVENTS.USER_CLASS_CONNECT, messageType: null}
    ]
  }
];

export const STUDENT_SOCKET_ROOM_EVENTS : SocketEventManage[] = [
  {
    socketEvent: APP_SOCKET_EVENTS.MEETING_EVENTS,
    appEvent: PRESENTATION_MODE_EVENTS.RESPONSE_EVENT,
    socketEmitEvents: [
      {socketEmit: SOCKET_EVENTS.connectStudent, messageType: EVENT_TYPES.userConnect}
    ]
  }
];


export const TEACHER_SOCKET_TASK_EVENTS : SocketEventManage[] = [
  {
    socketEvent: HOMEWORK_SOCKET_EVENTS.classTasksTopic,
    appEvent: HOMEWORKS_EVENTS.USER_JOINED_OR_LEFT_HOMEWORK,
    socketEmitEvents: [
      {socketEmit: HOMEWORK_SOCKET_EVENTS.connect, messageType: null}
    ]
  }
];


export const SHOW_SOCKET_DISCONNECTING_EVENT : string = 'SHOW_SOCKET_DISCONNECTING';
export const CLOSE_SOCKET_DISCONNECTING_EVENT : string = 'CLOSE_SOCKET_DISCONNECTING';
export const CLOSE_BOARD_SOCKET_DISCONNECTING_EVENT : string = 'CLOSE_BOARD_SOCKET_DISCONNECTING';
export const HIDE_DISCONNECTED_MODAL_EVENT : string = 'HIDE_DISCONNECTED_MODAL_EVENT';
export const DISCONNECTION_ALERT_TYPES = {
  toast: 'toastDisconnect'
};
export const OBTAIN_TOKEN_EVENT : string = 'OBTAIN_TOKEN';
export const RECONNECT_SOCKET_EVENT : string  = 'RECONNECT_SOCKET';
export const EMIT_JOIN_SOCKET_EVENT : string  = 'EMIT_JOIN_SOCKET_EVENT';
export const FORWARD_SOCKET_MESSAGES_EVENT : string = 'FORWARD_SOCKET_MESSAGES';
export const DISCONNECTED_SOCKET_EVENT: string = 'DISCONNECTED_SOCKET';
export const FORWARD_PRESENTATION_MESSAGES_EVENT : string = 'FORWARD_PRESENTATION_MESSAGES';
export const SHOW_DISCONNECTED_MODAL_EVENT : string = 'SHOW_DISCONNECTED_MODAL';

export const INITIAL_DATA_DEFAULT = {
  streamingChunkSize: 1048576,
  searchParamsAuthor: 'author',
  searchParamsPrice: 'price',
  wboMaxBoardSize: 65536,
  wboBlockedTools: [],
  wboMaxPencilPoints: 100,
  wboMaxEmitCountPeriod: 1024,
  activeIndexDB: true,
  expIndexDBDocumentTime: 30,
  fileExtensionsNotAllowed: [
    '.bat',
    '.exe',
    '.sh',
    '.jar',
    '.air',
    '.scr',
    '.vb',
    '.com',
    '.dll',
    '.bin',
    '.apk',
    '.cmd'
  ],
  webcatOauth2Logout: 'https://oauth2test.eduac.com:9999/auth/logout',
  searchParamsTitle: 'title',
  facebookRequestURI: 'oauth2/authorization/facebook',
  webcatOauth2Login: 'https://oauth2test.eduac.com:9999/auth/login',
  wboMaxEmitCount: 576,
  showLogin: true,
  webcatRequestURI: 'oauth2/authorization/webcat',
  socketUrl: 'https://test.eduac.com:10043/',
  bannerImages: [
    {
      id: 4,
      type: 'BANNER_WEB',
      order: 1,
      language: 'EN',
      url: '/img/banner/banner-1-BW_EN.jpg',
      createdBy: 1,
      createdDate: '2020-05-28T17:08:52.982809',
      modifiedBy: null,
      modifiedDate: null,
      archived: false
    },
    {
      id: 5,
      type: 'BANNER_WEB',
      order: 2,
      language: 'EN',
      url: '/img/banner/banner-2-BW_EN.jpg',
      createdBy: 1,
      createdDate: '2020-05-28T17:08:52.982809',
      modifiedBy: null,
      modifiedDate: null,
      archived: false
    },
    {
      id: 6,
      type: 'BANNER_WEB',
      order: 3,
      language: 'EN',
      url: '/img/banner/banner-3-BW_EN.jpg',
      createdBy: 1,
      createdDate: '2020-05-28T17:08:52.982809',
      modifiedBy: null,
      modifiedDate: null,
      archived: false
    }
  ],
  googleRequestURI: 'oauth2/authorization/google'
}

export const NETWORK_SETTINGS = {
  http: {
    defaultTimeout: 1000 * 30,
  },
  socketIo: {
    connection: {
      reconnectionAttempts: Infinity,
      timeout: 1000 * 30,
      reconnectionDelay: 1000,
      reconnectionDelayMax: 1000 * 5,
    },
    ackTimeout: 1000 * 60
  }
  
}
